import { useEffect, useState } from 'react';
import { isSystemBannerActive, useSystemBanners } from '../api/getSystemBanner';

// Re-evaluated every minute so banners appear and disappear on schedule without a refetch.
const ACTIVE_WINDOW_CHECK_INTERVAL_IN_MS = 60 * 1000;

const useNow = (intervalInMs: number) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), intervalInMs);
    return () => clearInterval(interval);
  }, [intervalInMs]);

  return now;
};

export const useActiveSystemBanners = () => {
  const { data: banners } = useSystemBanners();
  const now = useNow(ACTIVE_WINDOW_CHECK_INTERVAL_IN_MS);

  return (banners ?? []).filter((banner) => isSystemBannerActive(banner, now));
};
